// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
	text-align: left;
}

.close-button {
	margin-top: -6px;
	padding-right: 13px;
}

.content-title {
	font-family: MuseoSans-500;
	font-size: 24px;
	color: #15325F;
	letter-spacing: 0.01px;
}

.content-subtitle {
  margin-bottom: 8px;
	font-family: MuseoSans-500;
	font-size: 14px;
	color: #1F1F1F;
	letter-spacing: 0.01px;
  line-height: 24px;
}

 p {
	margin-bottom: 5px;
  margin-top: 16px;
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #1C1D1D;
	letter-spacing: 0.01px;
	line-height: 1.25;
}

:host >>> .content span {
	font-family: MuseoSans-500;
}

:host >>> .content b {
	font-family: MuseoSans-900;
}

.actions {
	position: relative;
	bottom: 20px;
	margin-top: 30px;
  text-align: right;
}

button {
	width: 160px;
}

.continue-position {
  margin-right: 8px;
}

.network-configuration {
  background: #F8F9FB;
  border: 1px solid #D1D6DB;
  box-sizing: border-box;
  margin-top: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
}

.network-configuration-selected {
  background: #E5F5FC;
  border: 1px solid #0073D0;
  box-sizing: border-box;
  margin-top: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
}

.config-title {
  font-family: MuseoSans-300;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  text-align: right;
  color: #1F1F1F;
  margin-left: 24px;
  width: 30%;
  float: left;
  margin-right: 8px;
}

.config-detail {
  font-family: MuseoSans-300;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 19px;
  color: #1F1F1F;

}

.disabled {
  color: #595E64 !important;
}

.no-config {
  font-family: MuseoSans-300;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  color: #1F1F1F;
  margin-left: 24px;
}

.img-location {
  margin-top: -30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/gateway-network-configuration/gateway-network-configuration.component.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;AACvB;;AAEA;EACE,kBAAkB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;EACrB,iBAAiB;AACnB;;CAEC;CACA,kBAAkB;EACjB,gBAAgB;CACjB,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;EACf,iBAAiB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".content {\n\ttext-align: left;\n}\n\n.close-button {\n\tmargin-top: -6px;\n\tpadding-right: 13px;\n}\n\n.content-title {\n\tfont-family: MuseoSans-500;\n\tfont-size: 24px;\n\tcolor: #15325F;\n\tletter-spacing: 0.01px;\n}\n\n.content-subtitle {\n  margin-bottom: 8px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 14px;\n\tcolor: #1F1F1F;\n\tletter-spacing: 0.01px;\n  line-height: 24px;\n}\n\n p {\n\tmargin-bottom: 5px;\n  margin-top: 16px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #1C1D1D;\n\tletter-spacing: 0.01px;\n\tline-height: 1.25;\n}\n\n:host >>> .content span {\n\tfont-family: MuseoSans-500;\n}\n\n:host >>> .content b {\n\tfont-family: MuseoSans-900;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tmargin-top: 30px;\n  text-align: right;\n}\n\nbutton {\n\twidth: 160px;\n}\n\n.continue-position {\n  margin-right: 8px;\n}\n\n.network-configuration {\n  background: #F8F9FB;\n  border: 1px solid #D1D6DB;\n  box-sizing: border-box;\n  margin-top: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.network-configuration-selected {\n  background: #E5F5FC;\n  border: 1px solid #0073D0;\n  box-sizing: border-box;\n  margin-top: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.config-title {\n  font-family: MuseoSans-300;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 19px;\n  text-align: right;\n  color: #1F1F1F;\n  margin-left: 24px;\n  width: 30%;\n  float: left;\n  margin-right: 8px;\n}\n\n.config-detail {\n  font-family: MuseoSans-300;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 19px;\n  color: #1F1F1F;\n\n}\n\n.disabled {\n  color: #595E64 !important;\n}\n\n.no-config {\n  font-family: MuseoSans-300;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 19px;\n  color: #1F1F1F;\n  margin-left: 24px;\n}\n\n.img-location {\n  margin-top: -30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
